import React from 'react';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Cell,
} from 'recharts';

const CHART_COLORS = [
  '#2a5298', '#7c3aed', '#db2777', '#dc2626', '#ea580c',
  '#ca8a04', '#16a34a', '#0891b2', '#4f46e5', '#9333ea',
  '#e11d48', '#0d9488',
];

function TimelineMiniChart({ byMonth, onBarClick }) {
  if (!byMonth || byMonth.length === 0) return null;

  // Show last 12 months, sorted ascending for the chart
  const data = [...byMonth]
    .sort((a, b) => a.month.localeCompare(b.month))
    .slice(-12)
    .map((item) => {
      const [year, month] = item.month.split('-');
      const date = new Date(parseInt(year), parseInt(month) - 1);
      return {
        month: item.month,
        label: date.toLocaleDateString('en-US', { month: 'short', year: '2-digit' }),
        count: item.count,
      };
    });

  return (
    <div className="timeline-chart-container">
      <h4 className="timeline-chart-title">Events by Month</h4>
      <ResponsiveContainer width="100%" height={180}>
        <BarChart data={data} margin={{ top: 4, right: 8, left: -16, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border, #e5e7eb)" />
          <XAxis
            dataKey="label"
            tick={{ fontSize: 11, fill: 'var(--color-text-secondary, #6b7280)' }}
            axisLine={{ stroke: 'var(--color-border, #e5e7eb)' }}
            tickLine={false}
          />
          <YAxis
            tick={{ fontSize: 11, fill: 'var(--color-text-secondary, #6b7280)' }}
            axisLine={false}
            tickLine={false}
            allowDecimals={false}
          />
          <Tooltip
            contentStyle={{
              backgroundColor: 'var(--color-card, #fff)',
              border: '1px solid var(--color-border, #e5e7eb)',
              borderRadius: 8,
              fontSize: 12,
            }}
            cursor={{ fill: 'rgba(42, 82, 152, 0.06)' }}
          />
          <Bar
            dataKey="count"
            radius={[4, 4, 0, 0]}
            cursor={onBarClick ? 'pointer' : 'default'}
            onClick={(data) => onBarClick && onBarClick(data.month)}
          >
            {data.map((entry, i) => (
              <Cell key={entry.month} fill={CHART_COLORS[i % CHART_COLORS.length]} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export default TimelineMiniChart;
